import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iqac-meetings',
  templateUrl: './iqac-meetings.component.html',
  styleUrls: ['./iqac-meetings.component.scss']
})
export class IqacMeetingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
